module.exports = "//public.getcloudapp.com/packs/media/images/zight-logomark-600-600-675ba4e57e35ad0a8c040a381fb0a0d1.svg";